import { ref, readonly } from 'vue'

export const useIsFacing = (initial) => {
  const state = ref(structuredClone(initial))

  const set = (value) => {
    state.value = value
  }

  const reset = () => {
    state.value = structuredClone(initial)
  }

  const clear = () => {
    state.value = ''
  }

  return { isFacing: readonly(state), set, reset, clear }
}